import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

export default [
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: { title: "Pregled" },
    component: () => import(/* webpackChunkName: "Tasks List" */ "@/Modules/Task/Views/List/List"),
    beforeEnter: ifAuthenticated
  }
]
